module.exports = __webpack_public_path__ + "static/media/logo.4f400dc6.svg";